module.exports = __webpack_public_path__ + "img/ajax-amsterdam.c54cab74.png";